import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every in-app navigation: scroll to top and clear focus from the previous page
 * so keyboard focus does not linger on unmounted or hidden controls.
 */
const RouteFocusReset = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    const pageBody = document.querySelector(".page-body");
    if (pageBody instanceof HTMLElement) {
      pageBody.scrollTop = 0;
    }

    const pageWrapper = document.querySelector(".page-body-wrapper");
    if (pageWrapper instanceof HTMLElement) {
      pageWrapper.scrollTop = 0;
    }

    if (window.innerWidth <= 991) {
      document.querySelector(".page-header")?.classList.add("close_icon");
      document.querySelector(".sidebar-wrapper")?.classList.add("close_icon");
    }

    const { activeElement } = document;
    if (activeElement instanceof HTMLElement && activeElement !== document.body) {
      activeElement.blur();
    }

    requestAnimationFrame(() => {
      if (pageBody instanceof HTMLElement) {
        pageBody.setAttribute("tabindex", "-1");
        pageBody.focus({ preventScroll: true });
        pageBody.removeAttribute("tabindex");
      }
    });
  }, [location.key]);

  return null;
};

export default RouteFocusReset;
